import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/syndycampaign.png'
import _imports_1 from '@/assets/images/copy-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-c2e71654"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "p-d-flex p-justify-between submission-details" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign", -1))
const _hoisted_4 = { class: "p-d-flex" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "brand-pic",
  src: _imports_0
}
const _hoisted_7 = { class: "p-flex-column p-ml-4" }
const _hoisted_8 = { class: "campaign-name" }
const _hoisted_9 = { class: "p-d-flex" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  class: "p-ml-2 p-mt-2",
  style: {"font-style":"normal","font-weight":"600","font-size":"12px","line-height":"15px","color":"#162020"}
}
const _hoisted_12 = {
  key: 0,
  class: "p-flex-column adaptive-column"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign CPI", -1))
const _hoisted_14 = { class: "p-mt-lg-6 p-mt-md-2" }
const _hoisted_15 = { class: "default-text" }
const _hoisted_16 = {
  key: 1,
  class: "p-flex-column adaptive-column"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign CPC", -1))
const _hoisted_18 = { class: "p-mt-lg-6 p-mt-md-2" }
const _hoisted_19 = { class: "default-text" }
const _hoisted_20 = {
  key: 2,
  class: "p-flex-column adaptive-column"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign CPM", -1))
const _hoisted_22 = { class: "p-mt-lg-6 p-mt-md-2" }
const _hoisted_23 = { class: "default-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { class: "default-text" }
const _hoisted_26 = { class: "p-flex-column adaptive-column" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign Period", -1))
const _hoisted_28 = { class: "p-mt-lg-6 p-mt-md-2" }
const _hoisted_29 = { class: "default-text" }
const _hoisted_30 = { class: "p-flex-column" }
const _hoisted_31 = { class: "p-mt-4" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-between p-col-12 p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Your Participation")
], -1))
const _hoisted_33 = { class: "p-d-flex main-name-block" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "link p-d-flex" }
const _hoisted_36 = ["href"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-between p-col-12 p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Comment")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            (_ctx.reasonData?.campaign?.photo.length > 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "brand-pic",
                  src: _ctx.reasonData?.campaign?.photo
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("img", _hoisted_6))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.reasonData?.campaign?.name), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  style: {"width":"26px","height":"26px","background":"rgba(232, 232, 232, 0.34)","border-radius":"20px"},
                  src: _ctx.reasonData?.campaign?.brand?.photo
                }, null, 8, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.reasonData?.campaign?.brand?.name), 1)
            ])
          ])
        ])
      ]),
      (_ctx.reasonData?.campaign?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.calculateCpiRate(_ctx.reasonData?.campaign?.cpi?.ios?.amount, _ctx.reasonData?.campaign?.appliedFee)) + " " + _toDisplayString(_ctx.reasonData?.campaign?.budget?.currency), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.reasonData?.campaign?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.calculateCpiRate(_ctx.reasonData?.campaign?.cpc?.amount, _ctx.reasonData?.campaign?.appliedFee)) + " " + _toDisplayString(_ctx.reasonData?.campaign?.budget?.currency), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.reasonData?.campaign?.paymentMethod === _ctx.CampaignPaymentMethod.CPM)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, "Amount: " + _toDisplayString(_ctx.calculateCpiRate(_ctx.reasonData?.campaign?.cpm?.amount, _ctx.reasonData?.campaign?.appliedFee)) + " " + _toDisplayString(_ctx.reasonData?.campaign?.budget?.currency), 1),
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, " Payout Cap: " + _toDisplayString(_ctx.calculateCpiRate(_ctx.reasonData?.campaign?.cpm?.payoutCap, _ctx.reasonData?.campaign?.appliedFee)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formatDate(_ctx.reasonData?.campaign?.dates?.startDate)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.reasonData?.campaign?.dates?.endDate) || 'Until Budget is Complete'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("span", {
            class: "red-text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'campaign', params: { campaignID: _ctx.reasonData?.campaign?.id }})))
          }, " view campaign details ")
        ])
      ])
    ]),
    _hoisted_32,
    _createVNode(_component_DataTable, {
      value: [_ctx.reasonData?.contentItem],
      responsiveLayout: "scroll",
      class: "p-mt-2 data-table"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, { header: "CONTENT" }, {
          body: _withCtx((campaign) => [
            _createElementVNode("section", _hoisted_33, [
              _createElementVNode("img", {
                src: campaign.data?.thumbnails?.default?.url
              }, null, 8, _hoisted_34)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "content link",
          header: "CONTENT LINK"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("a", {
                href: `https://www.youtube.com/watch?v=${ data?.vid }`,
                class: "link-bold eclipsis"
              }, _toDisplayString(`https://www.youtube.com/watch?v=${ data?.vid }`), 9, _hoisted_36),
              _createElementVNode("img", {
                src: _imports_1,
                class: "p-ml-2",
                style: {"cursor":"pointer"},
                onClick: ($event: any) => (_ctx.copyLink(`https://www.youtube.com/watch?v=${data?.vid}`))
              }, null, 8, _hoisted_37)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _hoisted_38,
    _withDirectives(_createElementVNode("textarea", {
      disabled: "",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reason) = $event))
    }, null, 512), [
      [_vModelText, _ctx.reason]
    ])
  ]))
}